export const Routes = {
  GET_SESSION_ID: 'https://api-store-dev.appcharge.com/store/orders/checkout-session/v2',
  CHECKOUT: '/checkout/v3',
  BOOT: '/v1/boot',
  PAYMENT: '/checkout/v3/finalize-payment',
  CANCEL_ORDER: '/checkout/v3/cancel',
  ADDRESS: '/checkout/v3/address-auto-complete',
  CALCULATE_TAX: '/checkout/v3/calculate-estimated-tax',
  HANDLE_DEFAULT_TAX: '/checkout/v3/handle-default-tax',
  APPLY_COUPON: '/checkout/v3/apply-promo-code',
  CANCEL_COUPON: '/checkout/v3/cancel-promo-code',
  ORDER: '/checkout/v3/orders',
  PAYMENT_STATUS: '/checkout/v3/payment/status',
  CREATE_SESSION: '/checkout/v3/payments/session',
  REMOVE_CARD: '/checkout/v3/remove-saved-card',
  THREE_DS_COMPLETE: '/checkout/v3/3ds/complete',
  NUVEI_APPLE_PAY_MERCHANT_SESSION: '/checkout/v3/nuvei/apple-pay/merchant-session',
  MARKETING_EMAIL_OPT_OUT: '/checkout/v3/marketing-email/opt-out',
  // Subscription (Chargebee) endpoints — served by the same backend that
  // powers independent-checkout-v2 and deliberately NOT under /checkout/v3.
  SUBSCRIPTION_SUMMARY: '/checkout/subscriptions',
  SUBSCRIPTION_FINALIZE: '/checkout/subscriptions/finalize-subscription',
  SUBSCRIPTION_CLOSE: '/checkout/subscriptions/close',
  SUBSCRIPTION_TAX: '/checkout/subscriptions/calculate-estimated-tax',
};

export const PciRoutes = {
  FINALIZE_PAYMENT: '/payment-pci-gw/checkout/finalize-payment',
};
